/* eslint-disable no-debugger */
export default function HandleInputTags(activeValue, activeState, values) {
  let tags = values[activeState]
  if (values[activeValue] && tags.indexOf(values[activeValue]) === -1) {
    tags = [...tags, values[activeValue]]
  }
  return tags
}
